// src/AppBootstrap.js
import { useEffect, useRef } from "react";
import { useAuth } from "./auth/AuthProvider";
import { useSettings } from "./settings";
import { apiFetch } from "./api";
import { initPush } from "./push";
import { useQueryClient } from "@tanstack/react-query";

export default function AppBootstrap() {
  const { isAuthed, auth } = useAuth();
  const { clearLocal, setSelectedWalletIdIfEmpty, settings } = useSettings();
  const queryClient = useQueryClient();

  const didPushInit = useRef(false);

  // identidade da sessão
  const customerId = auth?.customerId || null;
  const lastCustomerIdRef = useRef(null);

  // ✅ RESET quando desloga ou troca de usuário
  useEffect(() => {
    const last = lastCustomerIdRef.current;

    // 1) 🔴 Deslogou → limpa tudo (inclui settings)
    if (!isAuthed) {
      lastCustomerIdRef.current = null;
      didPushInit.current = false;

      try {
        clearLocal?.();
      } catch {}

      try {
        queryClient.clear();
      } catch {}

      return;
    }

    // 2) 🟢 Logou / trocou usuário → NÃO limpa settings aqui
    if (customerId && last !== customerId) {
      lastCustomerIdRef.current = customerId;
      didPushInit.current = false;

      // ❌ NÃO: clearLocal() aqui apagaria selectedWalletId recém-setado no login

      try {
        queryClient.clear();
      } catch {}
    }
  }, [isAuthed, customerId, clearLocal, queryClient]);

  // ✅ garante selectedWalletId assim que estiver authed
  useEffect(() => {
    if (!isAuthed) return;

    const defaultWalletId = Number(auth?.defaultWalletId) || null;

    // se não tem selectedWalletId, aplica o default do auth
    if (!settings?.selectedWalletId && defaultWalletId) {
      try {
        setSelectedWalletIdIfEmpty?.(defaultWalletId);
      } catch {}
    }
  }, [
    isAuthed,
    auth?.defaultWalletId,
    settings?.selectedWalletId,
    setSelectedWalletIdIfEmpty,
  ]);

  // 🔹 Push — 1x por usuário
  useEffect(() => {
    if (!isAuthed) return;
    if (!customerId) return;
    if (didPushInit.current) return;

    didPushInit.current = true;

    try {
      initPush({ apiFetch });
    } catch (e) {
      console.error("[AppBootstrap] initPush failed", e);
      didPushInit.current = false;
    }
  }, [isAuthed, customerId]);

  return null;
}
